/* eslint-disable camelcase */
import { featureFlipping } from '@bedrock-rdk/config';
import { sendImpressionEvent } from '../../../logic/analytics/analytics.utils';

const TRACKING_DEBOUNCE_MS = 1000;

const ANALYTICS_KEY = 'tealiumImpression';

let registry = {};

/** Exposed so callers can skip building the index lists at all while tracking is off */
export const isImpressionTrackingEnabled = () => featureFlipping.impressionTracking;

export const resetImpressions = () => {
  registry = {};
};

export const track = (block, items) => {
  if (!featureFlipping.impressionTracking) {
    return;
  }

  if (!registry[block]) {
    registry[block] = new Map();
  }

  const tracked = registry[block];
  const now = Date.now();

  for (let i = 0; i < items.length; i += 1) {
    if (!tracked.has(items[i])) {
      tracked.set(items[i], now);
    }
  }
};

export const untrack = (block, items) => {
  if (!featureFlipping.impressionTracking) {
    return;
  }

  if (!registry[block]) {
    return;
  }

  const tracked = registry[block];
  const now = Date.now();

  // An item seen for less than the debounce is dropped, one seen for longer stays counted
  if (items) {
    for (let i = 0; i < items.length; i += 1) {
      const trackedAt = tracked.get(items[i]);

      if (trackedAt !== undefined && now - trackedAt <= TRACKING_DEBOUNCE_MS) {
        tracked.delete(items[i]);
      }
    }

    return;
  }

  tracked.forEach((trackedAt, index) => {
    if (now - trackedAt <= TRACKING_DEBOUNCE_MS) {
      tracked.delete(index);
    }
  });
};

export const trackImpressions = layout => {
  if (!featureFlipping.impressionTracking) {
    return;
  }

  if (!layout || !layout.blocks || !layout.blocks.length) {
    return;
  }

  const blockIndexMap = Object.keys(registry).map(value => parseInt(value, 10));
  const list_of_block_viewed = [];
  const list_of_item_viewed = [];

  for (let i = 0; i < blockIndexMap.length; i += 1) {
    const blockIndex = blockIndexMap[i];
    const block = layout.blocks[blockIndex];

    if (!block || !block.content || !block.content.items) {
      // eslint-disable-next-line no-continue
      continue;
    }

    const blockImpression = {
      ...(block.analytics && block.analytics[ANALYTICS_KEY]),
      block_rank: blockIndex,
    };

    let minTimestamp = Number.POSITIVE_INFINITY;

    registry[blockIndex].forEach((trackedAt, itemIndex) => {
      const item = block.content.items[itemIndex];

      if (item) {
        if (trackedAt < minTimestamp) {
          minTimestamp = trackedAt;
        }

        list_of_item_viewed.push({
          ...(item.analytics && item.analytics[ANALYTICS_KEY]),
          hit_timestamp: trackedAt,
          block_rank: blockIndex,
          item_rank: itemIndex,
        });
      }
    });

    blockImpression.hit_timestamp = minTimestamp;

    list_of_block_viewed.push(blockImpression);
  }

  sendImpressionEvent(layout.analytics || {}, list_of_block_viewed, list_of_item_viewed);

  resetImpressions();
};
